export default __webpack_public_path__ + "static/select-border-789e1c426946499f4e69f9fb0a1b2dd7.svg";